'use client';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Col, Container, Row } from 'react-bootstrap';
import Title from '@/components/common/ui/text/Title';
import useContainerOffset from '@/components/hooks/useContainerOffset';
import { theme } from '@/components/features/theme/theme';
import ReactHtmlParser from 'react-html-parser';
import { StyledBannerAds } from '@/components/common/ygen/sections/banner-ads/bannerads.style';

const BannerAds = ({ data, carrer }) => {
	const offset = useContainerOffset('.container');

	// Memoize the subtitle to prevent unnecessary re-renders
	const subtitle = useMemo(() =>
			data?.subtitle || 'Creating <i>better</i> tomorrows',
		[data?.subtitle]
	);

	// Memoize the description to prevent unnecessary re-renders
	const description = useMemo(() =>
			data?.short_desc ?
				ReactHtmlParser(data.short_desc) :
				'Innovative engineering solutions. Shaping a sustainable tomorrow. Your future, our expertise.',
		[data?.short_desc]
	);

	// Memoize the container style to prevent unnecessary re-renders
	const containerStyle = useMemo(() => ({
		marginLeft: `${offset + 15}px`
	}), [offset]);

	return (
		<StyledBannerAds
			data-scroll
			offset={offset}
			style={containerStyle}
			className={`create-top-rebon ${carrer ? 'carrer' : ''}`}
			data-scroll-section
		>
			<Container fluid>
				<Row>
					<Col md={7}>
						<Title
							tag="h2"
							margin="0 0 40px"
							text={subtitle}
							color="#000"
						/>
						<p>{description}</p>
					</Col>
				</Row>
			</Container>
		</StyledBannerAds>
	);
};


export default React.memo(BannerAds);
